import { useCarrierCargoDetailPageProps } from "./fetch";
import { CarrierCargoDetailPageUi } from "./ui";

type RouteParams = { id: string | undefined };
export const CarrierCargoDetailPagePage = (params: RouteParams) => {
  const props = useCarrierCargoDetailPageProps(params.id);
  return <CarrierCargoDetailPageUi {...props} />;
};
